<template>
  <div class="main">
    <tab title='修改密码'></tab>
    <div class="input_box">
        <van-cell-group>
            <!-- 输入密码 -->
            <van-field v-model="password" type="password" maxlength="6" placeholder="请输入原密码" label="原密码" />
            <!-- 输入密码 -->
            <van-field v-model="newPassword" type="password" maxlength="6" placeholder="请输入新密码" label="新密码" />
            <!-- 输入密码 -->
            <van-field v-model="newPassword2" type="password" maxlength="6" placeholder="请输入再次输入新密码" label="请确认新密码" />
        </van-cell-group>
    </div>
    <div class="confirm_btn" @click="updPassword">确认</div>

  </div>
</template>

<script>
import tab from '@/components/NavBar'
import Vue from 'vue';
import { Field } from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';

Vue.use(Toast);
Vue.use(Field);

export default {
  name: 'margin',
  data () {
    return {
      password:'',
      newPassword:'',
      newPassword2:''
    }
  },
  components:{
      tab
  },
  methods:{
    updPassword(){
      console.log(this.newPassword)
      if(!this.password){
        Toast('请输入原密码');
        return
      }
      if(!this.newPassword){
        Toast('请输入新密码');
        return
      }
      if(this.newPassword=='123456'){
        Toast('密码不能为全顺序数字');
        return
      }
      if(!this.newPassword2){
        Toast('请再次输入新密码');
        return
      }
      if(this.newPassword2!=this.newPassword){
        Toast('两次密码不一致');
        return
      }
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
      });
      var data = {
        password:this.password,
        newPassword:this.newPassword,
        token:this.$storage.get('token')
      }
      this.$api.post('orgapp/changePassword',data,res=>{
        console.log(res.data)
        if (res.status >= 200 && res.status < 300) {
          var data = res.data
          Toast.clear();
          if(data.msg=="success"){
            Dialog.alert({
              title: '温馨提示',
              message: '修改成功',
            }).then(() => {
              // on close
              this.$router.go(-1);
            });
          }
        }else{
          Toast.clear();
          Toast.fail(res.status);
        }
      })
    }
  }
}
</script>

<style scoped>
.main {
    height: 100vh;
    background-color: #F7F8FA;
}
.input_box {
    margin-top: 30px;
}
.confirm_btn {
    width: 70%;
    height: 40px;
    margin: auto;
    margin-top: 20px;
    background-color: #1989FA;
    text-align: center;
    line-height: 40px;
    color: #fff;
    border-radius: 5px;
    /* animation: myAnimation 5s infinite; */
}
/* @keyframes myAnimation{
  0%{
    transform: scale(1)
  }
  25%{
    transform: scale(1.2)
  }
  50%{
    transform: scale(1)
  }
  75%{
    transform: scale(1.2)
  }
} */
</style>



// WEBPACK FOOTER //
// src/components/upd_password.vue